import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    chatInfo                : {},
    selectedChatId          : '',
    whatsappListFlag        : false,
    whatsappListOffset 	    : 0,
    noMoreWhatsappUsers     : false,
    whatsappUserSearch      : '',
    whatsappList            : {},
    isScrollList 		        : false,
    isEmptyView             : true,
    isOpenMessagesScr       : false,
    isResponsiveChat        : false,
    isMobileView            : false,
    messageInput            : '',
    windowWidth             : 0
  },
  getters: {
    getMessageInput : ( state ) => {
      return state.messageInput
    },
    getChatInfo : (state) => {
      return state.chatInfo;
    },
  },
  mutations: {
    updateWidgetType( state, payload){
      if( 'isResponsiveChat' in payload ) {
        state.isResponsiveChat = payload.isResponsiveChat;
        if(state.isMobileView){
          state.chatInfo = new Object();
        }
      }
  
      if( 'isMobileView' in payload ) {
        state.isMobileView = payload.isMobileView;
      }
  
    },
    updateChatInfo( state, payload ){
      if(Object.keys(payload).length == 0){
        Vue.set(state, 'chatInfo', {});
        Vue.set(state, 'messageInput', '');
      } else {
        Vue.set(state, 'chatInfo', payload.data);
        Vue.set(state, 'messageInput', '');
      }
    },
    updateTabListRecord(state, payload){
      if( Object.keys(state[payload.listType]).length && payload.isScrolling){
        let data = {...state[payload.listType], ...payload.list}
        Vue.set(state, payload.listType, data)
      } else {
        Vue.set(state, payload.listType, payload.list)
      }
  
    },
    updateWindowWidth(state, payload){
      state.windowWidth = payload.windowWidth;
    },
    updateMessageInput(state, payload){
      Vue.set(state, 'messageInput', payload.text);
    },
    updateSearch( state, payload){
      state[payload.search] = payload.searchValue;
    },
    updateRecordList( state, payload){
      state[payload.RecordList] = payload.RecordListValue;
    },
    // update the offset of list tabs
    updateOffset( state, payload){
      state[payload.offset] = payload.offsetValue;
    },
    //update flag the first time load tab data
    updateListFlag( state, payload){
      state[payload.flag] = payload.flagValue;
    },
    toggleMessagesScr( state, payload ){
      state.isEmptyView        = payload.isEmptyView;
      state.isOpenMessagesScr  = payload.isOpenMessagesScr;
    },
  },
  actions: {
    toggleMessagesScr(context, payload ) {
      context.commit('toggleMessagesScr', payload)
    },
    setUserProfile( context, payload ) {
      context.commit('setUserProfile', payload)
    },
  }
})